import "./index.scss"
import Sloth from "../../components/Sloth";

@Sloth.component({
    defaultOptions : {}
})

export default class Special {

    constructor() {
        this.open = false;
    }

    onInit() {
        if(window.screen.width > 720) return

        $(".Special-aside", this.dom).prepend($(".Special-aside-link.current", this.dom))


        $(document.body).on("click", (e) => {
            if($(e.target).parents(".Special-aside").length === 0){
                this.open = false
                this.render()
            }
        })

        $(this.dom).on("click", ".Special-aside-link.current", (e) => {
            e.preventDefault();
            this.open = !this.open;
            this.render()
        })
    }

    render() {
        if(this.open) $(".Special-aside", this.dom).addClass("open")
        else $(".Special-aside", this.dom).removeClass("open")
    }
}



/** WEBPACK FOOTER **
 ** ./src/Special/index.js
 **/